import { cn } from "@onclicks/sharedcomponents/ui";
import { cva, VariantProps } from "class-variance-authority";
import { ReactNode } from "react";
import Icon from "../shared/ui/icon";

const sectionVariants = cva(
  "bg-white dark:bg-slate-400/50 p-6 rounded-xl border",
  {
    variants: {
      variant: {
        default: "border-slate-200 dark:border-slate-200 shadow-sm",
        yellow: "border-primary/30 shadow-lg shadow-primary/5 top-24",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  } as const,
);

type SectionProps = VariantProps<typeof sectionVariants> & {
  children?: ReactNode;
  titre: string;
  icon?: string;
  soustitre?: string;
  className?: string;
  titleClassName?: string;
};

const Section = ({
  titre,
  icon,
  soustitre,
  children,
  variant,
  className,
  titleClassName,
}: SectionProps) => {
  return (
    <section className={cn(sectionVariants({ variant }), className)}>
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          {icon && (
            <div className="w-10 h-10 rounded-lg bg-primary/10 dark:bg-white/10 flex items-center justify-center text-primary dark:text-white">
              <Icon name={icon} />
            </div>
          )}
          <h3 className={cn("text-xl font-bold", titleClassName)}>{titre}</h3>
        </div>
        {soustitre && (
          <span className="text-sm font-bold text-white">{soustitre}</span>
        )}
      </div>

      {children}
    </section>
  );
};

export default Section;
